import Data from './HeroCarouselData';

const CarouselSidebar = (props) => {
  return <Data {...props} />;
};

export default CarouselSidebar;
